import { apiV2 } from '../api'
import { SacDadosAtendimento } from 'src/contexto/types'

export async function getSacInformation() {
  const { data } = await apiV2.get<SacDadosAtendimento>(
    `/canais/sac-dados-atendimento`
  )

  return data
}
